export default "/images/77cf1c40304799d212083c0562ae7bc2.jpg";